// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export let CrossRateData = function ()
{
    this.Symbol = null;
    this.Exp1 = null;
    this.Exp2 = null;
    this.Price = 0;
    this.IsReverse = false;
};

CrossRateData.prototype.toString = function ()
{
    return this.Exp1 + '/' + this.Exp2 + '=' + this.Price;
};
